import Alpine from "alpinejs";

const NP_KEY = "fbf02f02691e3bd68564b1ba085b89ba";
const NP_URL = "https://api.novaposhta.ua/v2.0/json/";

Alpine.data('np', () => ({
    apiKey: NP_KEY,
    apiUrl: NP_URL,
    citySearch: '',
    storeSearch: '',
    cityList: [],
    deliveryPrice: null,
    storeList: [],
    selectedCity: null,
    selectedCityRef: null,
    selectedStore: null,
    selectedStoreRef: null,
    deliveryPriceType: "WarehouseWarehouse",

    init() {
        this.fetchCity();
    },

    selectCity(city) {
        this.storeSearch = '';
        this.selectedStore = null;
        this.citySearch = city.Description;
        this.selectedCity = city.Description;
        this.selectedCityRef = city.Ref;
        this.fetchStore();
        this.updateDevileryPrice();
    },

    updateDevileryPrice() {
        this.selectedCityRef && window.dispatchEvent(new CustomEvent('city-selected', { detail: this.selectedCityRef }));
    },

    selectStore(store) {
        this.storeSearch = store.Description;
        this.selectedStore = store.Description;
        this.selectedStoreRef = store.Ref;
        if (this.selectedStore.includes('Поштомат')) {
            window.deliveryPriceType = "DoorsWarehouse"
            console.log("step 1 - ", window.deliveryPriceType);
            this.updateDevileryPrice();
        }
        else {
            window.deliveryPriceType = "WarehouseWarehouse"
            console.log("step 1 - ", window.deliveryPriceType);
            this.updateDevileryPrice();
        }
    },

    fetchCity() {
        const requestBody = {
            apiKey: this.apiKey,
            modelName: "Address",
            calledMethod: "getCities",
            methodProperties: {
                FindByString: this.citySearch,
                Language: "UA",
                Limit: "50",
                Page: 1,
            }
        };

        fetch(this.apiUrl, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
         .then(response => response.json())
         .then((data) => {
            this.cityList = data.data;
        });
    },

    fetchPrice(cityRef, price, weight, ) {
        const requestBody = {
            apiKey: this.apiKey,
            modelName: "InternetDocument",
            calledMethod: "getDocumentPrice",
            methodProperties: {
                CitySender: "db5c890b-391c-11dd-90d9-001a92567626",
                CityRecipient: cityRef,
                Weight: weight / 1000,
                ServiceType: window.deliveryPriceType || "WarehouseWarehouse",
                Cost: price,
                CargoType: "Parcel",
                SeatsAmount: 1
            }
        };

        fetch(this.apiUrl, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        }).then(response => response.json())
          .then((data) => {
            this.deliveryPrice = data.data[0].Cost
        });
    },

    searchCity() {
        const requestBody = {
            apiKey: this.apiKey,
            modelName: "Address",
            calledMethod: "getCities",
            methodProperties: {
                FindByString: this.citySearch,
                Language: "UA",
                Limit: "50",
                Page: 1,
            }
        };

        fetch(this.apiUrl, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        }).then(response => response.json())
          .then((data) => {
            this.cityList = data.data;
        });
    },


    fetchStore() {
        const requestBody = {
            apiKey: this.apiKey,
            modelName: "Address",
            calledMethod: "getWarehouses",
            methodProperties: {
                FindByString: this.storeSearch,
                CityRef: this.selectedCityRef,
                Language: "UA",
                Page: 1,
            }
        };

        fetch(this.apiUrl, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        }).then(response => response.json())
          .then((data) => {
            this.storeList = data.data;
        });
    },

    searchStore() {
        const requestBody = {
            apiKey: this.apiKey,
            modelName: "Address",
            calledMethod: "getWarehouses",
            methodProperties: {
                FindByString: this.storeSearch,
                CityRef: this.selectedCityRef,
                Language: "UA",
                Limit: "50",
                Page: 1,
            }
        };

        fetch(this.apiUrl, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        }).then(response => response.json())
          .then((data) => {
            this.storeList = data.data;
        });
    }
}));
